module.exports = __webpack_public_path__ + "static/media/playw.3413eaae.png";